import { useBuild } from "app/components/build/Show/lib/BuildContext";
import { useMemo } from "react";
import useQueryParams from "./useQueryParams";

/**
 * Hook for getting the current step ID from the URL based on either the step or job UUID.
 */
export default function useCurrentStepId() {
  const { store } = useBuild();
  const { stepUuid, jobUuid } = useQueryParams();

  return useMemo(() => {
    if (jobUuid && store?.jobs.has(jobUuid)) {
      return store.jobs.get(jobUuid)?.stepUuid || null;
    }

    if (stepUuid && store?.steps.has(stepUuid)) {
      return stepUuid;
    }

    return null;
  }, [store, jobUuid, stepUuid]);
}
